import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import * as PermisoService from '../../axios_services/permisosalida.service';

const ModalUpdateTipoSalidaPermiso = ({ isOpen, onClose, permiso, onRefresh }) => {
    const [esRemunerado, setEsRemunerado] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (isOpen && permiso) {
            setEsRemunerado(!!Number(permiso.es_remunerado));
        }
    }, [isOpen, permiso]);

    const handleActualizar = async () => {
        if (!window.confirm('¿Confirma la actualización del tipo de salida?')) return;
        setSaving(true);
        try {
            await PermisoService.updateTipoSalida({
                permiso_id: permiso.permiso_id,
                es_remunerado: esRemunerado
            });
            onRefresh();
            onClose();
        } catch (err) {
            alert(err.response?.data?.error || 'Error al actualizar el tipo de salida.');
        } finally {
            setSaving(false);
        }
    };

    if (!permiso) return null;

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>ACTUALIZAR TIPO DE SALIDA (PERMISO)</h1>
                    <Button className="close-btn" onClick={onClose}>X</Button>
                </div>
            </ModalHeader>

            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <Form className="fila" onSubmit={e => e.preventDefault()}>
                        <FormGroup>
                            <Label>Colaborador:</Label>
                            <Input
                                className="form-control"
                                type="text"
                                value={permiso.nombre_empleado || ''}
                                readOnly
                                style={{ background: '#f3f4f6', cursor: 'default' }}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Tipo de Salida:</Label>
                            <Input
                                className="form-control"
                                type="select"
                                value={esRemunerado ? '1' : '0'}
                                onChange={e => setEsRemunerado(e.target.value === '1')}
                            >
                                <option value="1">REMUNERADO</option>
                                <option value="0">NO REMUNERADO</option>
                            </Input>
                        </FormGroup>

                        <FormGroup style={{ marginTop: '18px' }}>
                            <div className="button-container">
                                <Button
                                    className="button-custom"
                                    onClick={handleActualizar}
                                    disabled={saving}
                                >
                                    {saving ? 'ACTUALIZANDO...' : 'ACTUALIZAR'}
                                </Button>
                            </div>
                        </FormGroup>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalUpdateTipoSalidaPermiso;
